import { createFileRoute } from '@tanstack/react-router';
import { AdminGuard } from '@/components/layout/AdminGuard';
import { useTrackSkillOnDwell } from '@/features/metric-hub/onboarding/use-skill-tracker';
import { SyncDashboardPage } from '@/features/metric-hub/sync-dashboard/SyncDashboardPage';

export const Route = createFileRoute('/_authed/metric-hub/sync-dashboard')({
  component: SyncDashboardRoute,
});

function SyncDashboardRoute() {
  useTrackSkillOnDwell('monitor_sync');
  return (
    <AdminGuard>
      <SyncDashboardPage />
    </AdminGuard>
  );
}
